import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHome, FiUsers, FiFileText, FiGlobe, FiDollarSign, FiBarChart3, FiSettings, FiCreditCard } = FiIcons;

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navItems = [
    { path: '/', icon: FiHome, label: 'Dashboard', exact: true },
    { path: '/agencies', icon: FiUsers, label: 'Agencies' },
    { path: '/articles', icon: FiFileText, label: 'Articles' },
    { path: '/domains', icon: FiGlobe, label: 'Domains' },
    { path: '/earnings', icon: FiDollarSign, label: 'Earnings' },
    { path: '/billing', icon: FiCreditCard, label: 'Billing' },
    { path: '/analytics', icon: FiBarChart3, label: 'Analytics' },
    { path: '/settings', icon: FiSettings, label: 'Settings' }
  ];

  return (
    <>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
      
      <motion.aside
        initial={{ x: -280 }}
        animate={{ x: isOpen ? 0 : -280 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        className="fixed left-0 top-0 h-full w-70 bg-white shadow-xl z-50 lg:relative lg:translate-x-0 lg:z-auto"
      >
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-800">ArticleHub</h1>
          <p className="text-sm text-gray-600 mt-1">Content Management</p>
        </div>
        
        <nav className="mt-8">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              className={({ isActive }) => 
                `flex items-center px-6 py-3 text-gray-700 hover:bg-primary-50 hover:text-primary-700 transition-colors ${
                  isActive ? 'bg-primary-50 text-primary-700 border-r-3 border-primary-500' : ''
                }`
              }
              onClick={() => window.innerWidth < 1024 && toggleSidebar()}
            >
              <SafeIcon icon={item.icon} className="w-5 h-5 mr-3" />
              {item.label}
            </NavLink>
          ))}
        </nav>
      </motion.aside>
    </>
  );
};

export default Sidebar;